import { render, staticRenderFns } from "./ListCoverQuoted.vue?vue&type=template&id=25b06d20"
import script from "./ListCoverQuoted.vue?vue&type=script&lang=js"
export * from "./ListCoverQuoted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports